import { Input, Modal, Tooltip } from 'antd';
import { MODAL_NAME } from 'constants/modal';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal } from 'store/reducers/modal';
import { WarningOutlined, CopyOutlined } from '@ant-design/icons';
import { CurlGenerator } from 'curl-generator';
import configEnv from 'env';
import { PROJECT_TYPE } from 'constants/constants';

const generateCurl = (projectId, stateInfo, apiKey) => {
  const { projectType, inputDesc } = stateInfo;
  let body = {
    input: inputDesc || {},
    dcsId: projectId,
    receiveResponse: true,
  };

  if (projectType === PROJECT_TYPE.ONE_TO_MANY) {
    body.repeat = 2;
  }

  return CurlGenerator({
    url: configEnv.CORE_BASE_URL + '/dcs/execute',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'api-key': apiKey || 'API_KEY',
    },
    body: body,
  });
};

const PopupIntegration = ({ isPageApprove, projectId, stateInfo }) => {
  const { open } =
    useSelector((state) => state.modal[MODAL_NAME.INTEGRATION]) || {};
  const dispatch = useDispatch();
  const [curl, setCurl] = useState();
  const [copy, setCopy] = useState();
  const apiKey = useSelector((state) => state.auth.apiKey);

  const onClickCopy = () => {
    navigator.clipboard.writeText(curl);
    setCopy(true);
  };

  const onMouseLeave = () => {
    setCopy();
  };

  const close = () => {
    dispatch(closeModal({ name: MODAL_NAME.INTEGRATION }));
  };

  useEffect(() => {
    setCurl(generateCurl(projectId, stateInfo, apiKey));
  }, [projectId, stateInfo, apiKey]);

  return (
    <Modal
      okText="Run"
      open={open}
      onCancel={close}
      title="Integration"
      className="integration-project"
      footer={null}
    >
      {!isPageApprove && (
        <div className="desc">
          <WarningOutlined /> Make sure this project approved.
        </div>
      )}
      <div className="integration-project__block" spellCheck={false}>
        <label className="integration-project__label">Curl</label>
        <Input.TextArea value={curl} rows={20} />
        <Tooltip title={copy ? 'Copied' : 'Copy'}>
          <CopyOutlined
            onClick={onClickCopy}
            onMouseLeave={onMouseLeave}
            className="integration-project__copy"
          />
        </Tooltip>
      </div>
    </Modal>
  );
};

export default PopupIntegration;
